import { match } from 'ts-pattern';
import { implementCustomExpressions } from '../__generated/implementation.js';
import { BendDirection, BendOrientation } from '../__generated/model/index.js';
import { round } from '../util/round.js';
export const anchorPointExpressions = implementCustomExpressions({
    AnchorPoint: {
        $relCoords: (self)=>{
            const { bottomLeft, topRight } = self.$shape.$boundingBox;
            const center = self.$shape.$center;
            const padding = self.$shape.$padding;
            const bottomLeftY = bottomLeft.y + padding.bottom;
            const bottomLeftX = bottomLeft.x + padding.left;
            const topRightY = topRight.y - padding.top;
            const topRightX = topRight.x - padding.right;
            return match(self.position).with('bottom', ()=>({
                    x: center.x,
                    y: bottomLeftY
                })).with('bottomLeft', ()=>({
                    x: bottomLeftX,
                    y: bottomLeftY
                })).with('bottomRight', ()=>({
                    x: topRightX,
                    y: bottomLeftY
                })).with('center', ()=>({
                    x: center.x,
                    y: center.y
                })).with('left', ()=>({
                    x: bottomLeftX,
                    y: center.y
                })).with('right', ()=>({
                    x: topRightX,
                    y: center.y
                })).with('top', ()=>({
                    x: center.x,
                    y: topRightY
                })).with('topLeft', ()=>({
                    x: bottomLeftX,
                    y: topRightY
                })).with('topRight', ()=>({
                    x: topRightX,
                    y: topRightY
                })).exhaustive();
        },
        $absCoords: (self)=>{
            const { x, y } = self.$shape.$absCoords;
            return {
                x: x + self.$relCoords.x,
                y: y + self.$relCoords.y
            };
        },
        $absCoords3D: (self)=>{
            const { x, y } = self.$shape.$absCoords;
            const plate = self.$plate;
            const bend = plate.$activeBend;
            const absX = round(x + self.$relCoords.x, 2);
            const absY = round(y + self.$relCoords.y, 2);
            if (!bend || bend.orientation === BendOrientation.Horizontal && absY <= bend.$middlePoint.y || bend.orientation === BendOrientation.Vertical && absX <= bend.$middlePoint.x) {
                return {
                    x: absX,
                    y: absY,
                    z: plate.thickness
                };
            }
            const middlePoint = bend.$middlePoint;
            if (bend.orientation === BendOrientation.Horizontal) {
                const absZ = absY - middlePoint.y + (bend.direction === BendDirection.Back ? plate.thickness : 0);
                return {
                    x: absX,
                    y: Math.min(absY, middlePoint.y),
                    z: bend.direction === BendDirection.Front ? -absZ : absZ
                };
            } else {
                const absZ = absX - middlePoint.x + plate.thickness;
                return {
                    x: Math.min(absX, middlePoint.x),
                    y: absY,
                    z: bend.direction === BendDirection.Front ? -absZ : absZ
                };
            }
        },
        $visible: (self)=>!self.$shape.$hiddenAnchorPoints.includes(self.position)
    }
});

//# sourceMappingURL=anchor-point.js.map